export function draftSnapshot(value) {
  return JSON.stringify(value, (key, item) => {
    if (item && typeof item.toMillis === "function") return item.toMillis();
    if (item && typeof item.path === "string" && typeof item.get === "function") return item.path;
    return item;
  });
}
export function createDraftTracker() {
  let baseline; let touched = false; let version = 0;
  return {
    touch(snapshot) {if (!touched) baseline = snapshot;touched = true;version += 1;},
    dirty(snapshot) {return touched && snapshot !== baseline;},
    checkpoint(snapshot) {return {snapshot, version};},
    saved(checkpoint) {
      if (checkpoint && checkpoint.version !== version) {baseline = checkpoint.snapshot;return;}
      touched = false;baseline = undefined;
    },
    reset() {touched = false;baseline = undefined;version += 1;},
  };
}
const drafts = new Map();const listeners = new Set();let snapshot = "";
function publish() {snapshot = [...new Set(drafts.values())].join(" · ");listeners.forEach(fn => fn());}
export const dirtyStore = {
  subscribe(fn) {listeners.add(fn);return () => listeners.delete(fn);},
  getSnapshot: () => snapshot,
  hasDirtyExcept: labels => [...drafts.values()].some(label => !labels.includes(label)),
  set(id, label, dirty) {if (dirty) drafts.set(id, label);else drafts.delete(id);publish();},
  remove(id) {drafts.delete(id);publish();},
};

// Lookup text, PDF selection and server audit metadata are not editable DO data.
export function operationDraftValue(order, containers) {
  const ignored = new Set(["cid", "ref", "createdAt", "createBy", "lastModifiedAt", "lastModifiedBy", "mod", "customerId", "customerName"]);
  return {order: Object.fromEntries(Object.entries(order).filter(([key]) => !ignored.has(key))),
    containers: Object.fromEntries(Object.entries(containers).filter(([key]) => key !== "selected"))};
}

// A save acknowledges only the child drafts present when that save started.
export function createDraftSaveGroup() {
  const members = new Map();
  return {
    register(id, member) {members.set(id, member);return () => members.delete(id);},
    checkpoint() {return [...members].map(([id, member]) => ({id, member, checkpoint: member.checkpoint()}));},
    saved(checkpoints = []) {
      for (const item of checkpoints) {
        if (members.get(item.id) === item.member) item.member.saved(item.checkpoint);
      }
    },
  };
}
